import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "../../assets/jss/Layout";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";

export default function Footer() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <CustomTypography id="praisoCopyrightText" className={clsx(classes.copyrightText, 'praisoCopyrightText')}>
        © {new Date().getFullYear()} {t("PRAISO_LTD")}. {t("ALL_RIGHTS_RESERVED")}.
      </CustomTypography>
    </>
  );
}
